import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FormFieldDataService {
  constructor(private httpClient: HttpClient) {}

  getData<T>(endpoint: string): Observable<T> {
    console.log('GET DATA');
    return this.httpClient.get<T>(endpoint).pipe(
      tap((res: any) => {
        console.error(res);
      }),
      catchError((err: any) => {
        console.error('error', err)
        return of(err)
      })
    );
  }
}
